"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddEnquiryCommentResponseDataDto = instanceOfAddEnquiryCommentResponseDataDto;
exports.AddEnquiryCommentResponseDataDtoFromJSON = AddEnquiryCommentResponseDataDtoFromJSON;
exports.AddEnquiryCommentResponseDataDtoFromJSONTyped = AddEnquiryCommentResponseDataDtoFromJSONTyped;
exports.AddEnquiryCommentResponseDataDtoToJSON = AddEnquiryCommentResponseDataDtoToJSON;
exports.AddEnquiryCommentResponseDataDtoToJSONTyped = AddEnquiryCommentResponseDataDtoToJSONTyped;
var EnquiryCommentFileDto_1 = require("./EnquiryCommentFileDto");
/**
 * Check if a given object implements the AddEnquiryCommentResponseDataDto interface.
 */
function instanceOfAddEnquiryCommentResponseDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('senderId' in value) || value['senderId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function AddEnquiryCommentResponseDataDtoFromJSON(json) {
    return AddEnquiryCommentResponseDataDtoFromJSONTyped(json, false);
}
function AddEnquiryCommentResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'],
        'message': json['message'],
        'senderId': json['senderId'],
        'createdAt': (new Date(json['createdAt'])),
        'file': json['file'] == null ? undefined : (0, EnquiryCommentFileDto_1.EnquiryCommentFileDtoFromJSON)(json['file']),
    };
}
function AddEnquiryCommentResponseDataDtoToJSON(json) {
    return AddEnquiryCommentResponseDataDtoToJSONTyped(json, false);
}
function AddEnquiryCommentResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'message': value['message'],
        'senderId': value['senderId'],
        'createdAt': value['createdAt'].toISOString(),
        'file': (0, EnquiryCommentFileDto_1.EnquiryCommentFileDtoToJSON)(value['file']),
    };
}
